// extracted by mini-css-extract-plugin
module.exports =  {"root":"HfHRKWHfp53m653gfVNW"};